var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircledArrowUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 19.5,
    width: 19,
    height: 19,
    rx: 9.5,
    transform: "rotate(-90 0.5 19.5)",
    stroke: "#243342"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64485 8.58515L7.52485 10.7052C7.4302 10.799 7.37695 10.9268 7.37695 11.0602C7.37695 11.1935 7.4302 11.3213 7.52485 11.4152C7.71987 11.609 8.03483 11.609 8.22985 11.4152L9.99985 9.64515L11.7699 11.4152C11.9649 11.609 12.2798 11.609 12.4749 11.4152C12.5684 11.3208 12.6206 11.1931 12.6199 11.0602C12.6206 10.9272 12.5684 10.7995 12.4749 10.7052L10.3549 8.58515C10.261 8.49049 10.1332 8.43725 9.99985 8.43725C9.86653 8.43725 9.73874 8.49049 9.64485 8.58515Z",
    fill: "#243342"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledArrowUp);
export default __webpack_public_path__ + "static/media/circled-arrow-up.07b15b0ac0b1368878a70f7594f0281f.svg";
export { ForwardRef as ReactComponent };